// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import './plugins/vuetify'
import App from './App'
import router from './router'
import axios from 'axios'
import '@/assets/css/main.css'
import responsive from '@/mixins/responsive'

Vue.config.productionTip = false
Vue.mixin(responsive)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

axios.defaults.baseURL = process.env.VUE_APP_AXIOS_URL
